import { FunctionComponent } from 'react'
import { Typography } from '@mui/material'
import { IInfoCenterNewsItem } from 'types/info-center/news'
import { formatTimeStampToStandartDate } from 'hooks/date/formattedTime'

type Props = {
  newsItem: IInfoCenterNewsItem
}

export const NewsItem: FunctionComponent<Props> = ({ newsItem }) => {
  return (
    <>
      <Typography variant="caption">
        {formatTimeStampToStandartDate(newsItem.publishedAt)}
      </Typography>
      <Typography sx={{ marginTop: '16px' }} variant="body2">
        {newsItem.content}
      </Typography>
    </>
  )
}
